import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Navbar from "../../Navbar"
import Header from "../../Header";
import baseUrl from "../../BaseUrl";
import Loader from "../../Loader";
import axios from "axios";
import jwt_decode from "jwt-decode";
import Pagination from "react-js-pagination";
import formatDateTimeToPST from "../../PSTDateConvert";
import { saveAs } from 'file-saver';
import * as XLSX from "xlsx";

const ImportCallPassDiridTnHistory = () => {

	const navigate = useNavigate();

	const [name, setName] = useState('');
	const [timeZone, setTimeZone] = useState('');
	const [token, setToken] = useState('');
	const [expire, setExpire] = useState('');
	const [role, setRole] = useState('');
	const [access, setAccess] = useState([]);
	const [cid, setCid] = useState('');

	const [popupOpen, setPopupOpen] = useState(false);
	const [importHistory, setImportHistory] = useState([])
	const [page, setPage] = useState(1);
	const [totalItem, setTotalItem] = useState(0);
    const [loadingCount, setLoadingCount] = useState(0);
    

	useEffect(() => {
		if(role){
			getImportCallPassHistory();
		}
	}, [page, role]);

	useEffect(() => {
		refreshToken();
	}, []);

	useEffect(() => {
		if (cid) {
			checkPageAccess();
		}
	}, [cid]);

    const incrementLoading = () => setLoadingCount((prev) => prev + 1);
    const decrementLoading = () => setLoadingCount((prev) => Math.max(prev - 1, 0));

    useEffect(() => {
        setPopupOpen(loadingCount > 0);
    }, [loadingCount]);

	const axiosJWT = axios.create();
 
    axiosJWT.interceptors.request.use(async (config) => {
        const currentDate = new Date();
        if (expire * 1000 < currentDate.getTime()) {
            const response = await axios.get(`${baseUrl}/token`);
            config.headers.Authorization = `Bearer ${response.data.accessToken}`;
            setToken(response.data.accessToken);
            const decoded = jwt_decode(response.data.accessToken);
            setCid(decoded.cid);
            setName(decoded.name);
            setRole(decoded.role)
            setExpire(decoded.exp);
        }
        return config;
    }, (error) => {
        return Promise.reject(error);
    });

	const refreshToken = async () => {
        try {
            const response = await axios.get(`${baseUrl}/token`);
            
            setToken(response.data.accessToken);
            const decoded = jwt_decode(response.data.accessToken);
            setCid(decoded.cid);
            setName(decoded.name);
            setRole(decoded.role)
            setExpire(decoded.exp);
			setTimeZone(decoded.timezone)

        } catch (error) {
            if (error.response) {
                navigate("/");  
                window.location.reload();
            }
        }
    }

	const checkPageAccess = async () => {
        try {
            incrementLoading();
            // Fetch all required data            
            const customerDigitMappingResponse = await axios.get(`${baseUrl}/check-company-e911-access/${cid}`, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });

            const userAccessResponse = await axiosJWT.get(`${baseUrl}/user-access`, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
            
            const callPassDisplayIdentitiesSwitch = customerDigitMappingResponse.data.call_pass_display_identities_switch;
            const userCallPassDisplayIdentitiesSwitch = userAccessResponse.data.user_call_pass_display_identities_switch;
            decrementLoading();
            setAccess(userAccessResponse.data.results);
            // Conditional check for access
            if (
                callPassDisplayIdentitiesSwitch >= 1 &&
                userCallPassDisplayIdentitiesSwitch >= 1
            ) {
                console.log("Access granted to Import Call Pass Display Identity History page");
                // Proceed with page logic
            } else {
                navigate('/dashboard');
            }
        } catch (error) {
            console.error("Error checking page access:", error);
            navigate('/dashboard'); // Redirect in case of any error
        }
    };

	

	const getImportCallPassHistory = async () => {
        incrementLoading();
        let url = `${baseUrl}/import-call-pass-dirid-tn-history?page=${page}&limit=${20}`;
        if(role > 2){
            url += `&company=${cid}`;
        }
        const response = await axiosJWT.get(url, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        console.log(response.data);
        decrementLoading();
        setImportHistory(response.data.data)
        setTotalItem(response.data.totalItem)
    }
	    
	
	const handlePageChange = (pageNumber) => {
        // console.log(`active page is ${pageNumber}`);
        setPage(pageNumber);
    }

	const exportErrors = async (abx) => {
        console.log(abx, 'abx');
        // Handle both formats: with telephoneNumberImport array or just TN keys
        const telephoneNumbers = abx.telephoneNumberImport
            || Object.keys(abx).filter(key => !['importError', 'telephoneNumberImport'].includes(key) && /^\d+$/.test(key));

        // Prepare the data for the XLSX file
        const formattedData = telephoneNumbers.map((number) => ({
            "Telephone Number": String(number),
            "Status": abx[number] || ""
        }));
        const workbook = XLSX.utils.book_new();
        const worksheet = XLSX.utils.json_to_sheet(formattedData);
        XLSX.utils.book_append_sheet(workbook, worksheet, "Number List");

        // Write XLSX file
        const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });

        // Convert buffer to Blob
        const data = new Blob([excelBuffer], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });

        // Save File
        saveAs(data, "call_pass_dirid_tn.xlsx");
    };
    

    const getExportResult = async (id)=>{
        incrementLoading();
        const response = await axiosJWT.get(`${baseUrl}/import-call-pass-dirid-tn-export-result/${id}`,{
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        console.log(response.data.data)
        const exportResult = response.data.data
        
        await exportErrors(exportResult)

        decrementLoading();
    }

	const handleFileDownload = async (filePath, type) => {
        try {
            incrementLoading();
          // Make a request to your backend to get the pre-signed URL
          const path = `import_call_pass_dirid_tn/${type}/${filePath}`;
          const response = await axios.post(`${baseUrl}/get-dialed-number-file`, {path});
          const { presignedUrl } = response.data;
    
          // Create a temporary anchor element and trigger a download
          const link = document.createElement('a');
          link.href = presignedUrl;
          link.download = filePath.split('/').pop(); // Set the filename as the last part of the file path
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          decrementLoading();
        // const newTab = window.open('', '_blank');
        //   newTab.document.write('<html><head><title>JSON Object</title></head><body><pre>' + JSON.stringify(response.data, null, 2) + '</pre></body></html>');
        //   newTab.document.close();
        } catch (error) {
          console.error('Error downloading the file', error);
          decrementLoading();
        }
    };




  return (
	<div className="panelbox">
		<Navbar  token={token} access = {access}/>
		<div className="right-panel">
            <Header name={name} />
            {popupOpen && <Loader />}
			<div className="content-page">
				<div className="row">
					<div className="col-8">
						<div className="left-title">
							<h1>Import Call Pass Display Identity History</h1>
						</div>
					</div>

					<div className="col-4 top-right-buttons">
						<div className="export-btn addnew-button"><Link to="/import-call-pass-dirid-tn"><span>&larr;</span> Back</Link></div>
					</div>
				</div>

				<div className="common-white-shadow-background setting-section">
					<div className="row">
						<div className=" setting-section haft-whitebox">
							<div className="search-result-section">
								<h3></h3>
							</div>

							<table className="tablebox search-result-table">
								<thead>
									<tr>
										<th>Date ({timeZone})</th>
										<th>Company</th>
										<th>Name</th>
										<th>Input File</th>
										<th>Operation</th>
										<th>Result</th>
									</tr>
								</thead>
								<tbody>
									{importHistory.map((importItem, index) => (
										<tr key={index}>
											<td>{formatDateTimeToPST(importItem.created_at, timeZone, role)}</td>
											<td>{importItem.cname}</td>
											<td>{importItem.full_name}</td>
											<td><a href="#" onClick={() => handleFileDownload(importItem.input_path, "input")}>{importItem.input_path}</a></td>
											<td>{importItem.operation === 'A' ? 'Add' : 'Delete'}</td>
											<td>
												{importItem.status == 2 ? (
													<button onClick={() => { getExportResult(importItem.title)}}>
														<img src={`${process.env.PUBLIC_URL}/images/download.png`} alt="" />
													</button>
												) : importItem.status == 3 ? (
													<button onClick={() => { getExportResult(importItem.title)}} style={{background:'none',border:'none',cursor:'pointer',color:'red',fontWeight:'bold'}}>
														Failed
													</button>
												) : "In-Progress"}
											</td>
										</tr>))}
								</tbody>
							</table>

                                {totalItem > 20 && (<Pagination
                                    activePage={page}
                                    itemsCountPerPage={20}
                                    totalItemsCount={totalItem}
                                    pageRangeDisplayed={5}
                                    onChange={handlePageChange.bind(this)}
                                />)}
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
  )
}

export default ImportCallPassDiridTnHistory